/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

const FounderTeamMember = ({ image, name, role, description }) => {
    return (
        <div className="p-8 flex -mt-28 md:mt-0 flex-col justify-center items-center md:flex-row gap-6 md:gap-10 max-w-4xl">
            <div className="w-40 sm:w-64">
                <div className="w-full overflow-hidden bg-gray-800 border-[10px] sm:border-[16px] border-gray-800">
                    {image ? (
                        <img
                            src={image}
                            alt={`${name} - ${role}`}
                            className="w-full h-full object-cover"
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-gray-400">
                            Photo
                        </div>
                    )}
                </div>
            </div>
            <div className="md:w-2/3 lg:mt-10 flex flex-col justify-center items-center md:items-start">
                <h3 className="text-xl md:text-3xl text-white mb-1">{name}</h3>
                <p className="text-primary text-sm md:text-lg font-bold mb-4">{role}</p>
                <p className="text-gray-300 text-xs md:text-lg mb-6 text-center md:text-start">{description}</p>
                <div className="flex gap-4">
                    <a href="#" className="text-white hover:text-blue-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                            <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                        </svg>
                    </a>
                    <a href="#" className="text-white hover:text-blue-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                        </svg>
                    </a>
                    <a href="#" className="text-white hover:text-blue-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-twitter" viewBox="0 0 16 16">
                            <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    );
};

// Team member component for regular team members
const TeamMember = ({ image, name, role }) => {
    return (
        <div className="border-[12px] sm:border-[16px] border-gray-800 bg-gray-800 h-full">
            <div className="w-full aspect-square overflow-hidden mb-4">
                {image ? (
                    <img
                        src={image}
                        alt={`${name} - ${role}`}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400">
                        Photo
                    </div>
                )}
            </div>
            <h3 className="text-base md:text-3xl font-medium text-white mb-1">{name}</h3>
            <p className="text-gray-300 text-xs md:text-[16px] font-extrabold mb-3">{role}</p>
            <div className="flex gap-2">
                <a href="#" className="text-white hover:text-blue-400">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                    </svg>
                </a>
                <a href="#" className="text-white hover:text-blue-400">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                    </svg>
                </a>
                <a href="#" className="text-white hover:text-blue-400">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-twitter" viewBox="0 0 16 16">
                        <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                    </svg>
                </a>
            </div>
        </div>
    );
};

export default function Team() {
    // Team members data
    const founder = {
        id: 1,
        image: '/assets/Alex_bowden.jpg',
        name: 'Alexander Bowden',
        role: 'Founder & Product Lead',
        description: 'A decade in creative teach, production and app innovations. The vision behind Everest Apps.'
    };

    const teamMembers = [
        {
            id: 2,
            image: '/assets/Daniel_bowden.jpg',
            name: 'Daniel Bowden',
            role: 'Senior Technical Advisor'
        },
        {
            id: 3,
            image: '/assets/pradeep.jpg',
            name: 'Pradip',
            role: 'Head of Mobile Development'
        },
        {
            id: 4,
            image: '/assets/Manish.jpg',
            name: 'Manish',
            role: 'Senior Backend Engineer'
        },
        {
            id: 5,
            image: '/assets/Bipin.jpg',
            name: 'Bipin',
            role: 'Junior Developer'
        },
    ];

    return (<>
        <div className="pt-32 md:pt-40 px-4 " style={{ background: 'linear-gradient(297.01deg, #2196F3 -116.99%, #000000 100%)' }}>
            <div className="container mx-auto max-w-6xl">
                {/* Header section */}
                <div className="text-center pb-28 md:pb-20">
                    <h1 className="text-3xl md:text-6xl font-bold text-white mb-6">Built by Experts.<br />Backed by Passion.</h1>
                    <p className="text-sm md:text-2xl text-white max-w-xs md:max-w-full mx-auto">
                        Our global team of senior developers, strategists, and creators brings real-world experience to every app we build.
                    </p>
                </div>
            </div>
        </div>
        <div className="bg-[#00101D]">
            <div className="container mx-auto max-w-6xl">
                {/* Founder section */}
                <div className="mb-10 md:pt-20 flex justify-center">
                    <FounderTeamMember {...founder} />
                </div>

                {/* Team grid */}
                <div className="grid grid-cols-2 px-4 md:grid-cols-4 gap-4 sm:gap-6">
                    {teamMembers.map(member => (
                        <div key={member.id}>
                            <TeamMember {...member} />
                        </div>
                    ))}
                </div>

                {/* Bottom section */}
                <div className="text-center mt-20">
                    <h2 className="text-3xl md:text-6xl font-bold text-white pb-16 px-20">Local leadership, global reach</h2>
                </div>
            </div>
        </div>
    </>);
}